import { Directive, ElementRef, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

@Directive({
  selector: '[tsIntersectionObserver]',
})
export class IntersectionObserverDirective implements OnDestroy {
  @Input() rootMargin: string = '0px'; // Optional: adjust margin
  @Output() intersect: EventEmitter<void> = new EventEmitter();

  private observer!: IntersectionObserver;

  constructor(private el: ElementRef) {
    this.createObserver();
  }

  private createObserver(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.intersect.emit(); // Emit event when the element is in view
          }
        });
      },
      { rootMargin: this.rootMargin }
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect(); // Clean up observer when directive is destroyed
    }
  }
}
